import React from 'react';// eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import styles from './Navigation.scss';
import * as LoginActions from '../../actioncreators/LoginActions';
import BaseReactComponent from '../Util/BaseReactComponent';
import {connect} from 'react-redux';
import classNames from 'classnames';
import baseComponent from '../../decorators/baseComponent';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

@connect(state => ({
    user: state.login.user,
    login: state.login
}))
@baseComponent(styles) class Navigation extends BaseReactComponent {

    static propTypes = {
        className: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            items: []
        };
    }

    componentWillUpdate(nextProps) {
        if (!nextProps.items) {
            this.state.items = [];
        } else {
            this.state.items = nextProps.items;
        }
    }

    performlogout(e) {
        e.preventDefault();
        LoginActions.logoutUser()(this.props.dispatch);
        if (this.context.router) {
            this.context.router.push(`/login`);
        }
    }

    gotoChangePassword() {
        this.context.router.push('/changepassword');
    }

    gotoHomePage() {
        this.context.router.push('/');
    }

    openSubMenu = (event) => {
      // This prevents ghost click.
      event.preventDefault();

      this.setState({
        open: true,
        anchorEl: event.currentTarget,
      });
    }

    handleRequestClose = () => {
      this.setState({
        open: false,
      });
    };

    gotoChangeProfile() {
        this.context.router.push('/changeprofile');
    }

    render() {
        let self = this;
        let roles = this.props.user ? this.props.user.roles : [];

        let x = "";
        if (typeof window !== 'undefined') {
            x = window.location.pathname;
        }

        let menuItems = this.state.items.map(function (r) {
            if (r && r.role && r.path && roles.includes(r.role)) {

                let classes = classNames({
                    active: r.path === x
                });

                return <li className={classes}><Link className="Navigation-link" to={r.path}>{self.getMessage('nav.' + r.name)}</Link></li>;
            }
            return undefined;
        });

        let userMenu;
        if (this.props.login.user && this.props.showMenu) {
            userMenu = (
                <div className="username">
                    <a onClick={(e) => this.openSubMenu(e)}>{this.props.login.user.username} <span className="glyphicon glyphicon-menu-down"></span></a>
                </div>);
        } else {
            userMenu = (
                <div className="username"></div>
            );
        }

        let showProfile = roles !== undefined && (roles.includes('INSTALLER_COMPANY') || roles.includes('ZEHNDER'));

        return (
            <nav className="Navigation">
                <div className="nav-wrapper clearfix">

                    <div className="nav-right col-xs-12">
                        {userMenu}
                    </div>

                  <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    onRequestClose={this.handleRequestClose}
                    animation={PopoverAnimationVertical}
                  >
                    <Menu>
                      <MenuItem primaryText={this.getIntlMessage('menu.home')} onTouchTap={(e) => {this.gotoHomePage()}} />
                      <MenuItem primaryText={this.getIntlMessage('menu.change-profile')} onTouchTap={(e) => {this.gotoChangeProfile()}} />
                      <MenuItem primaryText={this.getIntlMessage('menu.change-password')} onTouchTap={(e) => {this.gotoChangePassword()}} />
                      <MenuItem primaryText={this.getIntlMessage('menu.logout')} onTouchTap={(e) => {this.performlogout(e)}} />
                    </Menu>
                  </Popover>

                    <ul className="nav-right col-xs-12" style={{display: this.state.submenuVisibility ? 'block' : 'none'}}>
                        <div className="login-container">
                            <div><a className="Navigation-link" onClick={this.gotoHomePage.bind(this)}>{this.getIntlMessage('menu.home')}</a></div>
                            {showProfile ? <div><a className="Navigation-link" onClick={this.gotoChangeProfile.bind(this)}>{this.getIntlMessage('menu.change-profile')}</a></div> : <span></span>}
                            <div><a className="Navigation-link" onClick={this.gotoChangePassword.bind(this)}>{this.getIntlMessage('menu.change-password')}</a></div>
                            <div><a className="Navigation-link" onClick={this.performlogout.bind(this)}>{this.getIntlMessage('menu.logout')}</a></div>
                        </div>
                    </ul>
                </div>
            </nav>
        );
    }

}
const types = Navigation.contextTypes;
Navigation.contextTypes = {
    ...types,
    router: React.PropTypes.object.isRequired
};

Navigation.propTypes = {
    items: React.PropTypes.array,
    submenuVisibility: React.PropTypes.bool
};

Navigation.defaultProps = {
    showMenu: true
};

export default Navigation;



// WEBPACK FOOTER //
// /src/components/Navigation/Navigation.js